import React, { Component } from 'react'
import { Container } from 'reactstrap'
import { NavMenu } from './NavMenu'
import Footer from './Footer'

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
      <div id="layout">
        <NavMenu />
        <Container className="mb-4 mt-4">
          {this.props.children}
        </Container>
        <Footer />
      </div>
    );
  }
}
